export const user_routes = [
    // {
    //     path: '/',
    //     name: 'index',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/dashboard/Dashboard" } },
    //     meta: { requireAuth: false, requireAdmin: false },
    // },
    {
        path: '/file_browser',
        name: 'file_browser',
        component: () => import('@/components/FileBrowser'),
        // props: { data: { page: "pages/tv/TV" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/dashboard/Dashboard" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/menu',
        name: 'menu',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/menu/Menu" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/category',
        name: 'category',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/category/Category" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/filter',
        name: 'filter',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/filter/Filter" } },
        meta: { requireAuth: true, requireAdmin: false },
    },

    {
        path: '/banners',
        name: 'banner',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/banner/Banner" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    // {
    //     path: '/statistics',
    //     name: 'statistics',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/statistics/Statistics" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/doyouknow',
    //     name: 'doyouknow',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/doyouknow/Doyouknow" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/cocktail',
    //     name: 'cocktail',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/cocktail/Cocktail" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/manufacturer',
    //     name: 'manufacturer',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/manufacturer/Manufacturer" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/products',
    //     name: 'products',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/products/Products" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/product_type',
    //     name: 'product_type',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/product_type/ProductType" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/weight_unit',
    //     name: 'weight_unit',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/manufacturer/Manufacturer" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/length_unit',
    //     name: 'length_unit',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "pages/manufacturer/Manufacturer" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    {
        path: '/authors',
        name: 'authors',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/author/Author" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/posts',
        name: 'posts',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/post/Post" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/projects',
        name: 'projects',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/tv/TV" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    // {
        //     path: '/tv_channels1',
        //     name: 'tv_channels1',
        //     component: () => import('@/pages/tv/TV'),
        //     // props: { data: { page: "pages/tv/TV" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    {
        path: '/social_network',
        name: 'social_network',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/social_network/SocialNetwork" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "pages/contact/Contact" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
];
